// @flow

import React, { Component } from 'react';
import styled from 'styled-components';

import BorderedIcon from "../../../components/BorderedIcon";
import ArrowRightIcon from '../../../components/Icons/ArrowRight';


import colors from '../../../assets/css/colors';
import { above } from '../../../assets/css/media';
import IconLinkStyled from './IconLinkStyled';
import LeagueBase from './LeagueBase';
import getLinkStates from './getLinkStates';

const LiveDraftLabel = styled.div`
	text-transform: uppercase;
	font-size: 14px;
	font-weight: bold;
	line-height: 1.57;
	color: #ffffff;
	background: ${colors.liveGreen};
	border-radius: 2px;
	padding: 0 10px;
	margin: 5px 15px;

	&:before {
		content: '';

		${above.phone`
			content: 'Draft is ';
		`}
	}
`;

type Props = {
	league: Object,
	is_commissioner: boolean
};

class LiveDraftLeague extends Component<Props> {
	renderRightSide = () => {
		const { league, is_commissioner } = this.props;
		const links = getLinkStates(league, is_commissioner);

		return (
			<React.Fragment>
				<LiveDraftLabel>Live</LiveDraftLabel>
				<IconLinkStyled to={links.arrow} title="Go to League">
					<BorderedIcon hover={colors.lightGreen}>
						<ArrowRightIcon
							cursor="pointer"
							size="1.875"
							color={colors.nrlDarkGreen}
						/>
					</BorderedIcon>
				</IconLinkStyled>
			</React.Fragment>
		);
	}

	render() {
		const { league, is_commissioner } = this.props;

		return (
			<LeagueBase
				league={league}
				is_commissioner={is_commissioner}
				is_live_draft
				show_teams_count
				renderRightSide={this.renderRightSide}
			/>
		);
	}
}

export default LiveDraftLeague;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/LiveDraftLeague.js